import PermissionGate from "../../layout/PermissionGate";
import OrderLog from "../OrderLog";

const OrderStatusLog = ({ id }) => {
  return (
    <div className="row g-5 g-lg-10 mt-4">
      <div className="col p-0 mb-xl-10">
        <div className="d-flex w-100 justify-content-between mb-5">
          <div className="d-flex text-start text-dark fw-bold m-0 fs-3">
            Order Status Log
          </div>
        </div>
        <PermissionGate required={`view_order_log`}>
          <div className="card py-7">
            {/*begin::Card body*/}
            <div className="card-body py-4 text-center">
              {/*begin::Table*/}
              <OrderLog id={id} />
              {/*end::Table*/}
            </div>
            {/*end::Card body*/}
          </div>
        </PermissionGate>
      </div>
    </div>
  );
};

export default OrderStatusLog;
